import '../../../assets/login.css';

import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { Button } from 'shards-react';
import { auth } from '../../../firebase-init';
import InputAuth from '../../../components/UI/Input/InputAuth';

const ResetPassword = (props) => {
  const { submitHandler, field, loading, sendPasswordResetEmail, showResendPasswordResetBtn, showResetPassword } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <div className="col-lg-12 col-sm-12 login-banner">
      <div className="row d-flex justify-content-center ">
        {showResetPassword === true ? (
          <div className="col-lg-5 registration-card">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <h2 className="login-card-title p-2">{t('reset-password.title')}</h2>
                </div>
                <div className="col-12">
                  <form>
                    <div className="col-12 form-group ">
                      <div className="form-group mb-3">
                        <InputAuth
                          type="password"
                          className={` form-control  pt-3 pb-3 `}
                          id="password"
                          placeholder={t('reset-password.password')}
                          {...field('password')}
                        />
                      </div>

                      <div className="form-group login-form-input">
                        <InputAuth
                          type="password"
                          className={` form-control  pt-3 pb-3 `}
                          id="password-confirmation"
                          placeholder={t('reset-password.password-confirmation')}
                          {...field('password_confirm')}
                        />
                        {showResendPasswordResetBtn && (
                          <button
                            className=" input-divider reset-password-btn"
                            type="button"
                            disabled={loading}
                            onClick={() => sendPasswordResetEmail()}
                          >
                            <span className="glyphicon glyphicon-repeat"></span> {t('profile.form.resend-reset-password')}{' '}
                          </button>
                        )}
                      </div>
                      <div className="valid-feedback">{t('reset-password.reset')}</div>
                      <div className="d-flex flex-column justify-content-md-center mt-3">
                        <Button
                          className="btn btn-warning  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                          type="button"
                          disabled={loading}
                          onClick={() => submitHandler()}
                          style={{ fontSize: '20px' }}
                        >
                          <span
                            className="spinner-border "
                            role="status"
                            aria-hidden="true"
                            style={{ display: loading === true ? 'block' : 'none' }}
                          ></span>
                          <span className=""> {t('reset-password.reset')}</span>
                        </Button>
                        {!auth.currentUser && (
                          <div className="row mr-2 ml-2 mt-2 d-flex justify-content-between">
                            <div className="text-center  ">
                              <a href="login">{t('reset-password.connect')} </a>
                            </div>

                            <div className="text-center ">
                              <span>
                                {t('login.form.not-registered')} <a href="registration"> {t('login.form.register')} </a>
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          loading && (
            <div className="col-lg-5 registration-card" style={{ marginTop: '250px' }}>
              <div className="container">
                <div className="row mt-2 d-flex justify-content-between">
                  <div className="col-12 text-center" style={{ display: loading === true ? 'block' : 'none' }}>
                    <h2 className="login-card-title p-2">
                      {t('email-verification.title')}
                      <span className="spinner-border  " role="status" aria-hidden="true"></span>
                    </h2>
                  </div>

                  <div className="col-lg-12"></div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
